import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b7672cfe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b7672cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7672cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7672cfe')) {
      api.createRecord('b7672cfe', component.options)
    } else {
      api.reload('b7672cfe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b7672cfe&scoped=true&", function () {
      api.rerender('b7672cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hFCXK7G64gei/JS/comp/GuestBox.vue"
export default component.exports